import { render, staticRenderFns } from "./op-data-chart.vue?vue&type=template&id=72147a05&scoped=true"
import script from "./op-data-chart.ts?vue&type=script&lang=ts&external"
export * from "./op-data-chart.ts?vue&type=script&lang=ts&external"
import style0 from "./op-data-chart.less?vue&type=style&index=0&id=72147a05&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72147a05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72147a05')) {
      api.createRecord('72147a05', component.options)
    } else {
      api.reload('72147a05', component.options)
    }
    module.hot.accept("./op-data-chart.vue?vue&type=template&id=72147a05&scoped=true", function () {
      api.rerender('72147a05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/operational-data/op-data-chart/op-data-chart.vue"
export default component.exports